import './index.css'
import 'react-mdl/extra/material.css'
import 'react-mdl/extra/material.js'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

const rootEl = document.getElementById('root')

ReactDOM.render(<App />, rootEl)

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    ReactDOM.render(<NextApp />, rootEl)
  })
}



// WEBPACK FOOTER //
// ./src/index.js